import { render, staticRenderFns } from "./PageEvent.vue?vue&type=template&id=33ac6df0&scoped=true"
import script from "./PageEvent.vue?vue&type=script&lang=js"
export * from "./PageEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ac6df0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33ac6df0')) {
      api.createRecord('33ac6df0', component.options)
    } else {
      api.reload('33ac6df0', component.options)
    }
    module.hot.accept("./PageEvent.vue?vue&type=template&id=33ac6df0&scoped=true", function () {
      api.rerender('33ac6df0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/PageEvent.vue"
export default component.exports